/**
 * SharePoint service — API calls for SharePoint connector configuration and folder mappings.
 */

import { api } from './api';

export interface SharePointConfig {
  tenant_id: string;
  client_id: string;
  client_secret: string;
  site_url: string;
}

export interface SharePointMapping {
  id: string;
  company_id: string;
  company_name?: string;
  sharepoint_site_url: string;
  folder_path: string;
  created_at: string;
  updated_at: string;
}

export interface SharePointMappingCreatePayload {
  company_id: string;
  sharepoint_site_url: string;
  folder_path: string;
}

export interface SharePointMappingUpdatePayload {
  company_id?: string;
  sharepoint_site_url?: string;
  folder_path?: string;
}

export const sharepointService = {
  async getConfig(): Promise<SharePointConfig> {
    const response = await api.get<{ data: SharePointConfig }>('/admin/sharepoint/config');
    return response.data;
  },

  async updateConfig(payload: SharePointConfig): Promise<SharePointConfig> {
    const response = await api.put<{ data: SharePointConfig }>('/admin/sharepoint/config', payload);
    return response.data;
  },

  async listMappings(): Promise<SharePointMapping[]> {
    const response = await api.get<{ data: SharePointMapping[] }>('/admin/sharepoint/mappings');
    return response.data;
  },

  async createMapping(payload: SharePointMappingCreatePayload): Promise<SharePointMapping> {
    const response = await api.post<{ data: SharePointMapping }>('/admin/sharepoint/mappings', payload);
    return response.data;
  },

  async updateMapping(id: string, payload: SharePointMappingUpdatePayload): Promise<SharePointMapping> {
    const response = await api.put<{ data: SharePointMapping }>(`/admin/sharepoint/mappings/${id}`, payload);
    return response.data;
  },

  async deleteMapping(id: string): Promise<void> {
    await api.delete(`/admin/sharepoint/mappings/${id}`);
  },
};
